import "core-js/modules/es.string.link.js";
import React from 'react';
import Box from 'components/Box';
import Button from 'components/Button';
import Text from 'components/Text';
import { CardLink, Image, Subtitle } from '../shared';
var TinyHorizontalCard = function TinyHorizontalCard(_ref) {
  var _ref$isImageLeft = _ref.isImageLeft,
    isImageLeft = _ref$isImageLeft === void 0 ? false : _ref$isImageLeft,
    icon = _ref.icon,
    _ref$imageSource = _ref.imageSource,
    imageSource = _ref$imageSource === void 0 ? '' : _ref$imageSource,
    link = _ref.link,
    title = _ref.title,
    subtitle = _ref.subtitle,
    buttonProps = _ref.buttonProps;
  var imageBox = /*#__PURE__*/React.createElement(Box, {
    width: 90,
    background: "shaded"
  }, /*#__PURE__*/React.createElement(Image, {
    link: link,
    icon: icon,
    iconScale: 1,
    aspectRatio: 2 / 3,
    src: imageSource
  }));
  return /*#__PURE__*/React.createElement(Box, {
    background: "shaded",
    borderRadius: "large",
    display: "flex",
    overflow: "hidden",
    alignItems: "center",
    textAlign: "left"
  }, isImageLeft && imageBox, /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true,
    px: "s",
    py: 10,
    position: "relative"
  }, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    as: "h3",
    size: "xs",
    lineHeight: 1.4,
    overflow: "wrap"
  }, /*#__PURE__*/React.createElement(CardLink, {
    link: link,
    maxLength: 85
  }, title)), subtitle && /*#__PURE__*/React.createElement(Subtitle, {
    size: "xxs",
    mt: "xxxs"
  }, subtitle)), !isImageLeft && imageBox, buttonProps && /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Button, {
    iconOnly: true,
    icon: buttonProps.icon,
    variant: "transparent",
    size: "small",
    mr: "xs",
    onClick: buttonProps.onClick
  }, buttonProps.label)));
};
TinyHorizontalCard.displayName = 'TinyHorizontalCard';
export default TinyHorizontalCard;